<p>
  {{message}}
</p>
